

export function graphQlErrorMessage(errorObject, customMessages = []){
  if(!errorObject.graphQLErrors || errorObject.graphQLErrors.length === 0)
    return errorObject.message

  return errorObject.graphQLErrors.reduce((fullMessage, error) => {
    const customMessage = customMessages.find(m => m.code === error.code)

    return customMessage ? `${fullMessage}\n${customMessage.message}` : `${fullMessage}\n${error.message}`

  }, '').trim()
}

/**
 * Returns a user-friendly error message from a webtask.io error object
 * @param {DateTime} errorObject webtask.io error response object
 * @param {Object} customMessages array containing custom error messages: [ { pattern:RegEx, message:String } ]
 *
 * @return {Boolean}
 */
export function webtaskErrorMessage(errorObject, customMessages = []){
  let custom = null
  if( errorObject && errorObject.response && errorObject.response.text )
    custom = customMessages.find(m => m.pattern.test( errorObject.response.text ))

  return custom ? custom.message : JSON.parse(errorObject.response.text).message
}
